(function(){
  if (window.__brfDp) return; window.__brfDp = 1;
  var doc = document, NS = 'http://www.w3.org/2000/svg';
  var data; try { data = JSON.parse(doc.getElementById('brf-dp-data').textContent); } catch (e) { return; }

  /* Metres for each style at 115cm and 150cm wide, per size band (typical commercial pattern envelopes). */
  var ADULT = ['UK 6–10', 'UK 12–16', 'UK 18–22', 'UK 24–28'], KIDS = ['Age 3–4', 'Age 5–6', 'Age 7–8', 'Age 9–10', 'Age 11–12'];
  var STYLES = [
    {k: 'shift', n: 'Shift', d: 'Sleeveless, knee length', a: [2.0, 2.3, 2.6, 2.9], b: [1.3, 1.5, 1.8, 2.1]},
    {k: 'skater', n: 'Skater', d: 'Fitted top, flared knee skirt', a: [2.4, 2.7, 3.0, 3.3], b: [1.7, 1.9, 2.2, 2.5]},
    {k: 'wrap', n: 'Wrap', d: 'V neck, flutter sleeves, midi', a: [3.0, 3.3, 3.6, 3.9], b: [2.2, 2.4, 2.7, 3.0]},
    {k: 'maxi', n: 'Maxi', d: 'Empire line, floor length', a: [3.5, 3.8, 4.1, 4.5], b: [2.6, 2.8, 3.1, 3.4]},
    {k: 'slip', n: 'Slip', d: 'Bias cut, thin straps, midi', a: [2.8, 3.1, 3.4, 3.7], b: [2.2, 2.4, 2.6, 2.9]},
    {k: 'prom', n: 'Ball gown', d: 'Sweetheart top, full skirt', a: [5.5, 6.0, 6.5, 7.0], b: [4.2, 4.6, 5.0, 5.4]},
    {k: 'abaya', n: 'Abaya', d: 'Long sleeves, floor length', a: [3.8, 4.0, 4.3, 4.6], b: [2.9, 3.1, 3.3, 3.6]},
    {k: 'girls', n: 'Girls’ party', d: 'Puff sleeves, full skirt', kids: 1, a: [1.3, 1.6, 1.9, 2.2, 2.5], b: [0.9, 1.1, 1.4, 1.6, 1.9]}
  ];
  var PATS = [
    {k: 'plain', n: 'Plain or small print', x: 0, why: 'Pieces can be cut any way up, so nothing extra is needed.'},
    {k: 'nap', n: 'One-way', s: '+10%', x: .10, why: 'Velvet, sequins, pile and one-way prints must all be cut the same way up, which takes about 10% more.'},
    {k: 'match', n: 'Stripes or checks', s: '+15%', x: .15, add: .25, why: 'Big prints, stripes and checks need matching at the seams, which takes about 15% more plus one repeat.'}
  ];
  var SKINS = ['#F1D3BC', '#D9A982', '#A8714D', '#6E4630'];

  /* this fabric's usable width in cm: the title first (150cm, 60"), then the width metafield, else 140 */
  function widthCm(){
    var t = data.title || '', m = /(\d{3})\s*cm/i.exec(t);
    if (m) return +m[1];
    m = /(\d{2})\s*(?:"|”|''|inch)/i.exec(t); if (m) return Math.round(+m[1] * 2.54);
    m = /(\d{2,3})\s*(?:–|-|cm|\+)/.exec(data.width || ''); if (m) return +m[1];
    return 140;
  }
  var W = widthCm();
  var low = ((data.type || '') + ' ' + data.title + ' ' + (data.tags || []).join(' ')).toLowerCase();
  var PAT0 = /tartan|check|stripe|gingham|plaid/.test(low) ? 'match' : (/velvet|velour|sequin|fur|corduroy|pile|glitter/.test(low) ? 'nap' : 'plain');
  var SHEER = /tulle|net|chiffon|organza|voile|lace|georgette/.test(low);

  function metres(st, si, pk){
    var a = st.a[si], b = st.b[si], m;
    if (W <= 115) m = a * 115 / W;
    else if (W < 150) m = a + (b - a) * (W - 115) / 35;
    else m = b * Math.max(.78, Math.sqrt(150 / W));
    var p = PATS.filter(function(x){ return x.k === pk; })[0] || PATS[0];
    m = m * (1 + p.x) + (p.add || 0);
    return Math.ceil(m * 10 - 1e-6) / 10;
  }

  /* ---------- drawing ---------- */
  /* smooth closed path through points [x, y, corner?] (Catmull-Rom, corners keep a sharp turn) */
  function smooth(P){
    var n = P.length, d = 'M' + P[0][0] + ',' + P[0][1];
    for (var i = 0; i < n; i++) {
      var p1 = P[i], p2 = P[(i + 1) % n], p0 = p1[2] ? p1 : P[(i - 1 + n) % n], p3 = p2[2] ? p2 : P[(i + 2) % n];
      d += 'C' + r(p1[0] + (p2[0] - p0[0]) / 6) + ',' + r(p1[1] + (p2[1] - p0[1]) / 6) + ' ' + r(p2[0] - (p3[0] - p1[0]) / 6) + ',' + r(p2[1] - (p3[1] - p1[1]) / 6) + ' ' + p2[0] + ',' + p2[1];
    }
    return d + 'Z';
  }
  function r(v){ return Math.round(v * 10) / 10; }
  /* a shape symmetric about x=150 from its right half (top centre to bottom centre) */
  function sym(R){
    var L = R.slice(1, -1).reverse().map(function(p){ return [300 - p[0], p[1], p[2]]; });
    return smooth(R.concat(L));
  }
  function mir(R){ return R.map(function(p){ return [300 - p[0], p[1], p[2]]; }).reverse(); }

  var BODY = {
    torso: sym([[150, 88], [157, 92], [172, 99], [187, 108], [182, 132], [184, 146], [176, 170], [172, 186], [180, 212], [186, 240], [182, 262], [150, 268]]),
    neck: smooth([[143, 66], [157, 66], [157, 92], [158, 99], [150, 103], [142, 99], [143, 92]]),
    legR: smooth([[186, 238], [185, 290], [177, 340], [171, 372], [172, 410], [166, 470], [161, 512], [153, 513], [152, 470], [155, 410], [154, 372], [152, 320], [150, 262]]),
    armR: smooth([[180, 104], [193, 110], [200, 150], [207, 200], [214, 250], [220, 284], [224, 300], [222, 318], [214, 322], [210, 306], [206, 286], [196, 240], [190, 205], [184, 162], [180, 134]]),
    handR: smooth([[217, 282], [224, 300], [222, 318], [214, 322], [210, 306], [207, 288]]),
    shoeR: smooth([[152, 508, 1], [162, 508], [166, 522], [173, 540], [167, 547, 1], [152, 547, 1], [150, 530]])
  };
  var KID = {
    neck: smooth([[145, 248], [155, 248], [155, 266], [150, 270], [145, 266]]),
    legR: smooth([[166, 345], [164, 385], [160, 445], [161, 485], [158, 535], [151, 537], [151, 485], [152, 445], [151, 385], [150, 360]]),
    armR: smooth([[166, 272], [178, 279], [184, 315], [190, 355], [194, 385], [195, 397], [189, 401], [184, 389], [180, 359], [174, 321], [168, 295]]),
    handR: smooth([[192, 380], [195, 397], [189, 401], [184, 389]]),
    shoeR: smooth([[151, 532, 1], [159, 532], [163, 542], [164, 550], [151, 550, 1]])
  };

  /* dresses: right halves (mirrored), plus extras such as sleeves, straps and sashes */
  var DRESS = {
    shift: {p: [[150, 113], [158, 108], [164, 100, 1], [177, 102, 1], [183, 119], [182, 133], [186, 147], [180, 186], [188, 240], [191, 300], [193, 382, 1], [172, 386], [150, 387]], f: [186, 26, 386, 40, 2], arms: 1},
    skater: {p: [[150, 112], [159, 107], [164, 100, 1], [177, 102, 1], [183, 119], [182, 133], [185, 147], [176, 172], [172, 186, 1], [196, 232], [218, 300], [236, 368, 1], [200, 378], [150, 382]], f: [188, 22, 380, 84, 4], waist: 186, arms: 1},
    wrap: {p: [[150, 152, 1], [159, 126], [165, 99, 1], [184, 104], [187, 113, 1], [183, 134], [185, 147], [176, 172], [172, 186, 1], [190, 240], [205, 330], [218, 452, 1], [184, 459], [150, 462]], f: [190, 22, 460, 68, 3], waist: 186, arms: 1,
      x: [[[184, 103], [196, 108], [210, 138], [212, 152, 1], [197, 158, 1], [190, 142], [185, 128]], [[150, 180, 1], [180, 179], [180, 193], [150, 194, 1], [120, 193], [120, 179]], [[121, 184, 1], [112, 214], [108, 252, 1], [116, 252, 1], [118, 216], [126, 192]]], xm: [1, 0, 0]},
    maxi: {p: [[150, 130], [160, 125], [170, 113, 1], [178, 113, 1], [184, 128], [185, 146], [180, 162, 1], [193, 220], [207, 320], [221, 450], [232, 542, 1], [190, 549], [150, 551]], f: [164, 24, 548, 82, 4], waist: 162, arms: 1,
      st: [[171, 114, 168, 98], [177, 114, 176, 100]]},
    slip: {p: [[150, 124], [164, 116], [176, 114, 1], [184, 132], [184, 148], [176, 176], [174, 188], [186, 240], [188, 300], [190, 370], [194, 440, 1], [172, 446], [150, 448]], f: [200, 30, 446, 44, 2], arms: 1, sheen: 1,
      st: [[176, 115, 171, 99]]},
    prom: {p: [[150, 134, 1], [156, 124], [166, 120], [178, 122], [185, 130, 1], [182, 150], [174, 176], [171, 188, 1], [212, 240], [242, 330], [263, 450], [277, 544, 1], [230, 553], [150, 557]], f: [190, 22, 555, 126, 6], waist: 188, arms: 1},
    abaya: {p: [[150, 101], [156, 95], [162, 93, 1], [176, 98], [192, 106], [201, 132], [210, 200], [218, 268], [223, 292, 1], [204, 297, 1], [198, 252], [190, 196], [186, 162], [192, 240], [198, 350], [204, 460], [207, 544, 1], [180, 549], [150, 551]], f: [300, 46, 549, 56, 2], arms: 0,
      ln: [[150, 104, 150, 551], [204, 286, 223, 282]]},
    girls: {kid: 1, p: [[150, 268], [158, 266], [166, 270, 1], [170, 280], [168, 296, 1], [170, 308], [165, 333, 1], [190, 372], [205, 420], [212, 442, 1], [182, 449], [150, 451]], f: [335, 14, 450, 60, 4], waist: 333, arms: 1,
      x: [[[164, 266], [180, 270], [188, 285], [183, 298], [168, 296]], [[150, 327, 1], [167, 327], [167, 339], [150, 340, 1], [133, 339], [133, 327]]], xm: [1, 0]}
  };

  function el(n, a, kids){ var e = doc.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); (kids || []).forEach(function(c){ c && e.appendChild(c); }); return e; }

  /* the fabric fill for prints: a tile mirror-tiled 2 x 2 so it repeats without seams. A cleaned tile (creases lifted out,
     see clean() below) is used whole; a raw photo only by its centre half. */
  function fabric(id, img, T, whole, mode, ar){
    function pic(a){ var i = el('image', a); i.setAttribute('href', img); i.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', img); return i; }
    /* draped photo: once across each piece of the dress */
    if (mode === 'cover') return el('pattern', {id: id, patternContentUnits: 'objectBoundingBox', width: 1, height: 1}, [pic({width: 1, height: 1, preserveAspectRatio: 'xMidYMid slice'})]);
    /* flat photo made seamless: a plain repeat at the print's real size */
    if (mode === 'repeat') { var TH = T * (ar || 1); return el('pattern', {id: id, patternUnits: 'userSpaceOnUse', width: T, height: TH}, [pic({width: T, height: TH, preserveAspectRatio: 'none'})]); }
    var pat = el('pattern', {id: id, patternUnits: 'userSpaceOnUse', width: 2 * T, height: 2 * T});
    [[0, 0, ''], [T, 0, 'translate(100,0) scale(-1,1)'], [0, T, 'translate(0,100) scale(1,-1)'], [T, T, 'translate(100,100) scale(-1,-1)']].forEach(function(q){
      var s = el('svg', {x: q[0], y: q[1], width: T, height: T, viewBox: whole ? '0 0 100 100' : '25 25 50 50', preserveAspectRatio: 'none'});
      var im = el('image', {width: 100, height: 100, preserveAspectRatio: 'xMidYMid slice'});
      im.setAttribute('href', img); im.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', img);
      s.appendChild(q[2] ? el('g', {transform: q[2]}, [im]) : im);
      pat.appendChild(s);
    });
    return pat;
  }
  function grad(id, stops, x2, y2){
    return el('linearGradient', {id: id, x1: 0, y1: 0, x2: x2 == null ? 1 : x2, y2: y2 || 0}, stops.map(function(s){ return el('stop', {offset: s[0], 'stop-color': s[1], 'stop-opacity': s[2]}); }));
  }

  /* how the cloth catches the light, from its type and title */
  var FIN = {
    sparkle: /glitter|sequin|lurex|metallic|lam[eé]\b|sparkl|foil/.test(low),
    velvet: /velvet|velour/.test(low),
    sheen: /satin|taffeta|duchess|silk|charmeuse|organza|lam[eé]\b/.test(low),
    sheer: SHEER
  };
  function sparkles(id){
    var p = el('pattern', {id: id, patternUnits: 'userSpaceOnUse', width: 26, height: 26}), seed = 7;
    function rnd(){ seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (var i = 0; i < 9; i++) p.appendChild(el('circle', {cx: r(rnd() * 26), cy: r(rnd() * 26), r: r(.4 + rnd() * .9), fill: '#fff', 'fill-opacity': r(.35 + rnd() * .6)}));
    return p;
  }

  /* Product photos often show the fabric scrunched up, which looks wrong on a dress. Each colour's photo is read once
     (Shopify's CDN allows this) and cleaned: the light and shadow of the folds are lifted out by dividing by a heavily
     blurred copy. Plain fabrics then become one even colour (the median of the photo); prints become a flat tile.
     A variant can also carry its own flat photo in the custom.dress_tile metafield, which wins. */

  /* ---------- True-size prints from the ruler photo (2026-10-20) ----------
     Each fabric shoot includes one flat photo with a wooden ruler laid on the cloth. The planner finds it on its own:
     the ruler is a long, narrow, wood-coloured strip running the full length of the photo. Its millimetre ticks give
     the photo's exact scale (pixels per cm); the cloth beside the ruler becomes a sharp seamless tile, repeated on the
     dress at its real size, so a 5cm motif on the roll is 5cm on the model. Used for single-colour products, and for
     any colour whose own photo is the ruler shot. Anything else falls back to the colour photo as before. */
  var RULER = {};
  function sized(u, w){ u = String(u || ''); if (/^(data|blob):/.test(u)) return u; /* the customer's own photo (Fabric planner page): no ?width= on a data URL */ return /width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function loadImg(src, cb){ var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function(){ cb(im); }; im.onerror = function(){ cb(null); }; im.src = src; }
  function isWood(r, g, b){
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h;
    if (mx === mn || mx < 128) return false;
    var s = (mx - mn) / mx;
    if (mx === r) h = 60 * (((g - b) / (mx - mn) + 6) % 6); else if (mx === g) h = 60 * ((b - r) / (mx - mn) + 2); else h = 60 * ((r - g) / (mx - mn) + 4);
    return h >= 22 && h <= 55 && s >= .16 && s <= .78;
  }
  /* where the ruler lies, from a small copy: {v: true for an upright ruler, a0, a1 as fractions across}, or null */
  function findStrip(im){
    var W = 240, H = Math.max(40, Math.round(240 * im.naturalHeight / im.naturalWidth)), c = doc.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H); var d = x.getImageData(0, 0, W, H).data;
    function frac(n, m, at){ var f = []; for (var i = 0; i < n; i++) { var k = 0; for (var j = 0; j < m; j++) { var q = at(i, j); if (isWood(d[q], d[q + 1], d[q + 2])) k++; } f.push(k / m); } return f; }
    function strip(f, n){
      var best = null, s0 = -1;
      for (var i = 0; i <= n; i++) {
        var on = i < n && f[i] > .55;
        if (on && s0 < 0) s0 = i;
        if (!on && s0 >= 0) { if (!best || i - s0 > best[1] - best[0]) best = [s0, i]; s0 = -1; }
      }
      if (!best) return null;
      while (best[0] > 0 && f[best[0] - 1] > .2) best[0]--;
      while (best[1] < n && f[best[1]] > .2) best[1]++;
      var w2 = best[1] - best[0]; return w2 >= n * .03 && w2 <= n * .22 ? best : null;
    }
    var a = strip(frac(W, H, function(i, j){ return (j * W + i) * 4; }), W);
    if (a) return {v: true, a0: a[0] / W, a1: a[1] / W};
    var b = strip(frac(H, W, function(i, j){ return (i * W + j) * 4; }), H);
    if (b) return {v: false, a0: b[0] / H, a1: b[1] / H};
    return null;
  }
  /* pixels per cm from the ticks. The ruler is read along four lanes; in each, the strongest repeat between 2.5 and 20px
     is the millimetre (or a harmonic of it). At least two lanes must agree within 4%, and the photo must come out between
     15 and 80cm across, or the photo is not used for scale (the planner then falls back to the colour photo). */
  function measure(im, sp){
    var W = im.naturalWidth, H = im.naturalHeight, c = doc.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0);
    var L = sp.v ? H : W, A = sp.v ? W : H, b0 = Math.round(sp.a0 * A), b1 = Math.round(sp.a1 * A), bw = Math.max(1, b1 - b0);
    var d = (sp.v ? x.getImageData(b0, 0, bw, H) : x.getImageData(0, b0, W, bw)).data;
    var mms = [];
    for (var band = 0; band < 4; band++) {
      var j0 = Math.floor(bw * band / 4), j1 = Math.floor(bw * (band + 1) / 4), pr = new Float32Array(L), i, j;
      for (i = 0; i < L; i++) { var t = 0; for (j = j0; j < j1; j++) { var q = sp.v ? (i * bw + j) * 4 : (j * W + i) * 4; t += 255 - (.3 * d[q] + .59 * d[q + 1] + .11 * d[q + 2]); } pr[i] = t / Math.max(1, j1 - j0); }
      var R = 150, acc = 0, sm = new Float32Array(L);
      for (i = 0; i < L; i++) { acc += pr[i]; if (i >= 2 * R + 1) acc -= pr[i - 2 * R - 1]; sm[i] = pr[i] - acc / Math.min(i + 1, 2 * R + 1); }
      var lo = Math.floor(L * .05), hi = Math.ceil(L * .95);
      var pw = function(per){ var cs = 0, sn = 0, w = 2 * Math.PI / per; for (var k = lo; k < hi; k++) { cs += sm[k] * Math.cos(w * k); sn += sm[k] * Math.sin(w * k); } return cs * cs + sn * sn; };
      var bp = 0, bv = 0;
      for (var per = 2.5; per <= 20; per += .02) { var v = pw(per); if (v > bv) { bv = v; bp = per; } }
      if (!bp) continue;
      var mm = bp; [3, 2].forEach(function(k){ if (mm === bp && bp * k <= 20 && pw(bp * k) > .6 * bv) mm = bp * k; });
      mms.push(mm);
    }
    var best = null;
    mms.forEach(function(m, k){
      var agree = mms.filter(function(o){ return Math.abs(o - m) / m <= .04; });
      if (agree.length >= 2 && (!best || agree.length > best.n)) best = {n: agree.length, mm: agree.reduce(function(s2, o){ return s2 + o; }, 0) / agree.length};
    });
    if (!best) return null;
    var pxcm = best.mm * 10, across = W / pxcm;
    return across >= 15 && across <= 80 ? pxcm : null;
  }
  /* a square photo made into a tile that repeats without seams and without mirroring: the last 14% of the photo is faded
     in over the first 14%, across then down, so each tile runs straight on into the next (motifs keep their way up) */
  function seamless(src, S){
    /* 2026-11-02: first look for the print's own repeat and cut the tile to it (assets/brf-repeat.js): no join, no ghosting */
    var rt = window.brfRepeatTile && window.brfRepeatTile(src, S); if (rt) return {canvas: rt.canvas, keep: rt.keep, ar: rt.keepY / rt.keep};
    var F = Math.round(S * .14), T = S - F;
    function pass(from, w, h, across){
      var o = doc.createElement('canvas'); o.width = across ? T : w; o.height = across ? h : T;
      var ox = o.getContext('2d'); ox.drawImage(from, 0, 0);
      var t = doc.createElement('canvas'); t.width = across ? F : w; t.height = across ? h : F;
      var tx = t.getContext('2d'); tx.drawImage(from, across ? -T : 0, across ? 0 : -T);
      var g = across ? tx.createLinearGradient(0, 0, F, 0) : tx.createLinearGradient(0, 0, 0, F);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      tx.globalCompositeOperation = 'destination-in'; tx.fillStyle = g; tx.fillRect(0, 0, t.width, t.height);
      ox.drawImage(t, 0, 0); return o;
    }
    return {canvas: pass(pass(src, S, S, true), T, S, false), keep: T / S};
  }
  /* the cloth beside the ruler, as a square tile at up to 1100px, with its real width in cm */
  function rulerTile(im, sp, pxcm){
    var W = im.naturalWidth, H = im.naturalHeight, A = sp.v ? W : H, Lh = sp.v ? H : W, pad = A * .025;
    var g0 = sp.a0 * A - pad, g1 = A - sp.a1 * A - pad, from = g0 >= g1 ? 0 : sp.a1 * A + pad, wide = Math.max(g0, g1);
    var side = Math.floor(Math.min(wide, Lh) * .96); if (side < 120) return null;
    var off = Math.floor((Lh - side) / 2), sx = sp.v ? from + (wide - side) / 2 : off, sy = sp.v ? off : from + (wide - side) / 2;
    var N = Math.min(1100, side), c = doc.createElement('canvas'); c.width = c.height = N;
    var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(im, sx, sy, side, side, 0, 0, N, N);
    var sm = doc.createElement('canvas'); sm.width = sm.height = 1; var sx2 = sm.getContext('2d'); sx2.drawImage(c, 0, 0, 1, 1);
    var m = sx2.getImageData(0, 0, 1, 1).data;
    var sl = seamless(c, N);
    return {plain: false, color: 'rgb(' + m[0] + ',' + m[1] + ',' + m[2] + ')', tile: sl.canvas.toDataURL('image/jpeg', .9), mode: 'repeat', cm: side * sl.keep / pxcm, ar: sl.ar || 1};
  }
  function rulerCands(v){
    var own = v && v.img ? [v.img] : [];
    if (COLS.length > 1) return own;
    return own.concat(data.media || []).filter(function(u, i, a){ return u && a.indexOf(u) === i; });
  }
  function ruler(list, cb){
    var key = list.join('|'); if (RULER[key] !== undefined) { if (RULER[key] && RULER[key].wait) RULER[key].wait.push(cb); else cb(RULER[key]); return; }
    RULER[key] = {wait: [cb]};
    function done(r){ var w = RULER[key].wait; RULER[key] = r; w.forEach(function(f){ f(r); }); }
    var i = 0;
    (function next(){
      if (i >= list.length) return done(null);
      var u = list[i++];
      loadImg(sized(u, 300), function(sm){
        var sp = null; try { sp = sm && findStrip(sm); } catch (e) {}
        if (!sp) return next();
        loadImg(sized(u, 1600), function(big){
          var r = null; try { var pxcm = big && measure(big, sp); r = pxcm && rulerTile(big, sp, pxcm); } catch (e) {}
          if (r) done(r); else next();
        });
      });
    })();
  }

  var LOOKS = {}, PLAIN = /\bplain\b/.test(low);
  function look(v, done){
    var src = (v && v.tile) || imgOf(v);
    var lk = LOOKS[src];
    if (lk) { if (!lk.ready && done) lk.cbs.push(done); return lk; }
    lk = LOOKS[src] = {img: src, plain: false, ready: false, cbs: done ? [done] : []};
    var flat = !!(v && v.tile); /* a flat photo uploaded for the planner is always a print to repeat */
    lk.plain = true; lk.color = '#D8D2CA'; /* soft placeholder while the photo is read */
    function photo(){
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function(){ var c = null; try { c = clean(im, flat); } catch (e) {} finish(c); };
      im.onerror = function(){ finish(null); };
      im.src = sized(src, 1600);
    }
    function finish(c){
      if (c) { lk.plain = (c.plain || PLAIN) && !flat; lk.color = c.color; lk.tile = c.tile; lk.mode = c.mode; lk.keep = c.keep; lk.ar = c.ar; if (c.cm) { lk.cm = c.cm; lk.scaled = true; } }
      else { lk.plain = false; } /* the photo can't be read: fall back to its centre */
      lk.ready = true; var cbs = lk.cbs; lk.cbs = []; cbs.forEach(function(f){ f(lk); });
    }
    var cands = flat ? [] : rulerCands(v);
    if (cands.length) ruler(cands, function(r){ if (r) finish(r); else photo(); }); else photo();
    return lk;
  }
  function clean(im, flatOnly){
    var N = 640, w = im.naturalWidth, h = im.naturalHeight, m = Math.min(w, h) * .7;
    var c = doc.createElement('canvas'); c.width = c.height = N;
    var x = c.getContext('2d'); x.drawImage(im, (w - m) / 2, (h - m) / 2, m, m, 0, 0, N, N);
    var d = x.getImageData(0, 0, N, N), a = d.data, orig = x.getImageData(0, 0, N, N);
    /* sharp edges mean a print (folds are soft): the share of pixels that change brightness quickly */
    var e = 0, oa = orig.data, lum = function(p){ return .3 * oa[p] + .59 * oa[p + 1] + .11 * oa[p + 2]; };
    for (var yy = 0; yy < N - 3; yy += 2) for (var xx = 0; xx < N - 3; xx += 2) {
      var p0 = (yy * N + xx) * 4, l0 = lum(p0);
      if (Math.abs(lum(p0 + 12) - l0) > 16 || Math.abs(lum(p0 + N * 12) - l0) > 16) e++;
    }
    var edges = e / (((N - 3) >> 1) * ((N - 3) >> 1));
    /* the light across the cloth: the photo squeezed to 11 x 11 and stretched back, smoothly */
    var s = doc.createElement('canvas'); s.width = s.height = 11;
    s.getContext('2d').drawImage(c, 0, 0, 11, 11);
    var b = doc.createElement('canvas'); b.width = b.height = N;
    var bx = b.getContext('2d'); bx.imageSmoothingEnabled = true; bx.imageSmoothingQuality = 'high'; bx.drawImage(s, 0, 0, N, N);
    var L = bx.getImageData(0, 0, N, N).data;
    var n = N * N, i, Ls = [], R = [], G = [], B = [];
    for (i = 0; i < n * 4; i += 4) { Ls.push(.3 * L[i] + .59 * L[i + 1] + .11 * L[i + 2]); R.push(a[i]); G.push(a[i + 1]); B.push(a[i + 2]); }
    function med(arr){ var q = arr.slice().sort(function(p, o){ return p - o; }); return q[q.length >> 1]; }
    var Lm = med(Ls), s1 = 0, s2 = 0, q1 = 0, q2 = 0;
    for (i = 0; i < n; i++) {
      var k = Math.max(.5, Math.min(3.4, Lm / Math.max(5, Ls[i]))), j = i * 4;
      a[j] = Math.min(255, a[j] * k); a[j + 1] = Math.min(255, a[j + 1] * k); a[j + 2] = Math.min(255, a[j + 2] * k);
      var c1 = a[j] - a[j + 1], c2 = (a[j] + a[j + 1]) / 2 - a[j + 2];
      s1 += c1; s2 += c2; q1 += c1 * c1; q2 += c2 * c2;
    }
    /* prints keep their own photo, untouched: folds are rarely photographed on prints, and flattening would
       wash out big tone-on-tone motifs (e.g. pink flocked sunflowers on pink) */
    x.putImageData(orig, 0, 0);
    /* how much the colour changes across the cloth once the folds are gone: little means a plain fabric */
    var spread = Math.sqrt(Math.max(0, q1 / n - (s1 / n) * (s1 / n)) + Math.max(0, q2 / n - (s2 / n) * (s2 / n)));
    var col = 'rgb(' + med(R) + ',' + med(G) + ',' + med(B) + ')';
    /* Prints. A draped or scrunched photo (light swinging a lot across the cloth) can't be repeated without ugly
       squares, so it is laid over the dress once, like the cloth itself. A flat photo is turned into a seamless tile:
       the crop is blended with a copy of itself shifted by half, so the tile's edges meet invisibly. */
    var t = 0, tt = 0, k = 0;
    for (i = 0; i < n; i += 7) { t += Ls[i]; tt += Ls[i] * Ls[i]; k++; }
    var crease = Math.sqrt(Math.max(0, tt / k - (t / k) * (t / k))) / Math.max(1, t / k);
    var plain = spread < 15 && (edges < .03 || FIN.sparkle);
    if (!flatOnly && crease > .12) return {plain: plain, color: col, tile: c.toDataURL('image/jpeg', .9), mode: 'cover', crease: crease};
    /* flat photo: a seamless straight repeat (edges faded into each other, no mirroring, so motifs keep their way up) */
    var sl = seamless(c, N);
    return {plain: plain, color: col, tile: sl.canvas.toDataURL('image/jpeg', .9), mode: 'repeat', keep: sl.keep, ar: sl.ar || 1, crease: crease};
  }

  /* print scale: the model is about 3.2 units per cm (170cm tall). A product photo is taken to show about 30cm of
     cloth unless the product's custom.dress_photo_cm says otherwise; the shopper can nudge it with Print size. */
  var PHOTO_CM = +data.photoCm > 0 ? +data.photoCm : 30;
  function tileSize(lk){ return lk.cm ? 3.2 * lk.cm * (st.zoom || 1) : 3.2 * PHOTO_CM * (lk.tile ? .7 * (lk.keep || 1) : .5) * (st.zoom || 1); }

  var uid = 0;
  function dressNodes(D, fill, pre, plain){
    var g = el('g', {'class': 'brf-dp__dress'}), main = sym(D.p), clip = pre + 'c';
    var defs = el('defs', {}, [el('clipPath', {id: clip}, [el('path', {d: main})])]);
    g.appendChild(defs);
    g.appendChild(el('path', {d: main, fill: fill, 'fill-opacity': FIN.sheer ? .8 : 1}));
    /* a fine weave grain so plain colours read as cloth, not flat paint */
    if (plain) g.appendChild(el('path', {d: main, fill: '#fff', filter: 'url(#' + pre + 'n)', opacity: .32}));
    /* folds fan out from the waist to the hem */
    if (D.f) {
      var f = D.f, fg = el('g', {'clip-path': 'url(#' + clip + ')', filter: 'url(#' + pre + 'b)'});
      for (var i = -f[4]; i <= f[4]; i++) {
        var t = f[4] ? i / f[4] : 0;
        fg.appendChild(el('line', {x1: 150 + t * f[1], y1: f[0], x2: 150 + t * f[3], y2: f[2] + 6, stroke: '#000', 'stroke-opacity': plain ? .12 : .07, 'stroke-width': 7}));
        if (plain && i < f[4]) fg.appendChild(el('line', {x1: 150 + (t + .5 / f[4]) * f[1], y1: f[0], x2: 150 + (t + .5 / f[4]) * f[3], y2: f[2] + 6, stroke: '#fff', 'stroke-opacity': .13, 'stroke-width': 6}));
      }
      g.appendChild(fg);
    }
    /* round the body: dark at the sides, a soft highlight off centre */
    g.appendChild(el('path', {d: main, fill: 'url(#' + pre + 's)', opacity: plain ? 1 : .55}));
    /* finishes only on plain colours, so a print always shows as it is */
    if (plain && (D.sheen || FIN.sheen)) g.appendChild(el('path', {d: main, fill: 'url(#' + pre + 'v)'}));
    if (plain && FIN.velvet) g.appendChild(el('path', {d: main, fill: 'url(#' + pre + 'r)'}));
    if (plain && FIN.sparkle) g.appendChild(el('path', {d: main, fill: 'url(#' + pre + 'p)'}));
    if (D.waist) g.appendChild(el('path', {d: 'M100,' + D.waist + 'H200', stroke: '#000', 'stroke-opacity': .18, 'stroke-width': 1.2, 'clip-path': 'url(#' + clip + ')'}));
    (D.ln || []).forEach(function(l){ g.appendChild(el('path', {d: 'M' + l[0] + ',' + l[1] + 'L' + l[2] + ',' + l[3], stroke: '#000', 'stroke-opacity': .2, 'stroke-width': 1.2, 'clip-path': 'url(#' + clip + ')'})); });
    (D.ln || []).slice(1).forEach(function(l){ g.appendChild(el('path', {d: 'M' + (300 - l[0]) + ',' + l[1] + 'L' + (300 - l[2]) + ',' + l[3], stroke: '#000', 'stroke-opacity': .2, 'stroke-width': 1.2, 'clip-path': 'url(#' + clip + ')'})); });
    (D.st || []).forEach(function(s){
      [[s[0], s[2]], [300 - s[0], 300 - s[2]]].forEach(function(x){ g.appendChild(el('path', {d: 'M' + x[0] + ',' + s[1] + 'L' + x[1] + ',' + s[3], stroke: fill, 'stroke-width': 3, 'stroke-linecap': 'round'})); });
    });
    return g;
  }
  function extraNodes(D, fill, pre){
    var g = el('g', {'class': 'brf-dp__dress'});
    (D.x || []).forEach(function(P, i){
      var ds = [smooth(P)]; if (D.xm && D.xm[i]) ds.push(smooth(mir(P)));
      ds.forEach(function(d){ g.appendChild(el('path', {d: d, fill: fill, 'fill-opacity': FIN.sheer ? .8 : 1})); if (FIN.sparkle) g.appendChild(el('path', {d: d, fill: 'url(#' + pre + 'p)'})); g.appendChild(el('path', {d: d, fill: 'url(#' + pre + 'x)'})); });
    });
    return g;
  }

  function model(styleKey, lk, skin, big){
    var D = DRESS[styleKey], pre = 'brfdp' + (++uid), kid = !!D.kid;
    var fill = lk.plain ? lk.color : 'url(#' + pre + 'f)';
    var svg = el('svg', {viewBox: big ? (kid ? '70 170 160 390' : '40 -6 220 566') : dressBox(D), preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true'});
    if (big) svg.setAttribute('class', 'brf-dp__model');
    var defs = el('defs', {}, [
      lk.plain ? null : fabric(pre + 'f', lk.tile || lk.img, tileSize(lk), !!lk.tile, lk.mode, lk.ar),
      sparkles(pre + 'p'),
      el('radialGradient', {id: pre + 'r', cx: .45, cy: .35, r: .6}, [el('stop', {offset: 0, 'stop-color': '#fff', 'stop-opacity': .16}), el('stop', {offset: 1, 'stop-color': '#fff', 'stop-opacity': 0})]),
      el('filter', {id: pre + 'n', x: 0, y: 0, width: '100%', height: '100%'}, [
        el('feTurbulence', {type: 'fractalNoise', baseFrequency: big ? .9 : 1.6, numOctaves: 1, seed: 3, result: 't'}),
        el('feColorMatrix', {'in': 't', type: 'matrix', values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -1.6 1.05'}),
        el('feComposite', {in2: 'SourceGraphic', operator: 'in'})]),
      grad(pre + 's', [[0, '#000', .22], [.16, '#000', .04], [.3, '#000', 0], [.7, '#000', 0], [.84, '#000', .04], [1, '#000', .24]]),
      grad(pre + 'v', [[0, '#fff', 0], [.36, '#fff', .14], [.46, '#fff', 0], [.68, '#fff', .08], [.78, '#fff', 0]], .3, 1),
      grad(pre + 'x', [[0, '#000', .16], [.5, '#fff', .05], [1, '#000', .18]]),
      grad(pre + 'k', [[0, '#000', .22], [.35, '#000', 0], [.6, '#fff', .12], [1, '#000', .24]]),
      el('filter', {id: pre + 'b', x: '-20%', y: '-5%', width: '140%', height: '110%'}, [el('feGaussianBlur', {stdDeviation: 3.2})]),
      el('radialGradient', {id: pre + 'g', cx: .5, cy: .5, r: .5}, [el('stop', {offset: 0, 'stop-color': '#3A2E24', 'stop-opacity': .28}), el('stop', {offset: 1, 'stop-color': '#3A2E24', 'stop-opacity': 0})])
    ]);
    svg.appendChild(defs);
    if (!big) { svg.appendChild(dressNodes(D, fill, pre, lk.plain)); svg.appendChild(extraNodes(D, fill, pre)); return svg; }
    svg.appendChild(el('ellipse', {cx: 150, cy: 548, rx: kid ? 50 : (styleKey === 'prom' ? 140 : 70), ry: 9, fill: 'url(#' + pre + 'g)'}));
    var B = kid ? KID : BODY, sk = el('g', {fill: skin, 'class': 'brf-dp__skin'}), sh = 'url(#' + pre + 'k)';
    function skinPath(d){ sk.appendChild(el('path', {d: d})); sk.appendChild(el('path', {d: d, fill: sh})); }
    skinPath(B.legR); skinPath(smooth(mir((kid ? KIDRAW : RAW).legR)));
    var shoes = el('g', {fill: '#2A2420'}, [el('path', {d: B.shoeR}), el('path', {d: smooth(mir(kid ? KIDRAW.shoeR : RAW.shoeR))})]);
    if (!kid) skinPath(BODY.torso);
    skinPath(B.neck);
    svg.appendChild(sk); svg.appendChild(shoes);
    svg.appendChild(dressNodes(D, fill, pre, lk.plain));
    var ar = el('g', {fill: skin});
    var R0 = kid ? KIDRAW : RAW;
    if (D.arms) [B.armR, smooth(mir(R0.armR))].forEach(function(d){ ar.appendChild(el('path', {d: d})); ar.appendChild(el('path', {d: d, fill: sh})); });
    else [B.handR, smooth(mir(R0.handR))].forEach(function(d){ ar.appendChild(el('path', {d: d})); ar.appendChild(el('path', {d: d, fill: sh})); });
    svg.appendChild(ar);
    svg.appendChild(extraNodes(D, fill, pre));
    /* head and hair */
    var hy = kid ? 222 : 44, hr = kid ? [23, 26] : [20, 26];
    svg.appendChild(el('ellipse', {cx: 150, cy: hy, rx: hr[0], ry: hr[1], fill: skin}));
    svg.appendChild(el('ellipse', {cx: 150, cy: hy, rx: hr[0], ry: hr[1], fill: sh}));
    var hair = kid
      ? smooth([[150, 192], [170, 197], [178, 215], [179, 240], [172, 246, 1], [170, 222], [160, 206], [150, 203], [140, 206], [130, 222], [128, 246, 1], [121, 240], [122, 215], [130, 197]])
      : smooth([[150, 15], [168, 20], [174, 36], [172, 52, 1], [166, 34], [150, 27], [134, 34], [128, 52, 1], [126, 36], [132, 20]]);
    svg.appendChild(el('path', {d: hair, fill: '#2B211C'}));
    if (!kid) svg.appendChild(el('circle', {cx: 150, cy: 10, r: 11, fill: '#2B211C'}));
    return svg;
  }
  /* raw point lists, kept for mirroring */
  var RAW = {
    legR: [[186, 238], [185, 290], [177, 340], [171, 372], [172, 410], [166, 470], [161, 512], [153, 513], [152, 470], [155, 410], [154, 372], [152, 320], [150, 262]],
    armR: [[180, 104], [193, 110], [200, 150], [207, 200], [214, 250], [220, 284], [224, 300], [222, 318], [214, 322], [210, 306], [206, 286], [196, 240], [190, 205], [184, 162], [180, 134]],
    handR: [[217, 282], [224, 300], [222, 318], [214, 322], [210, 306], [207, 288]],
    shoeR: [[152, 508, 1], [162, 508], [166, 522], [173, 540], [167, 547, 1], [152, 547, 1], [150, 530]]
  };
  var KIDRAW = {
    legR: [[166, 345], [164, 385], [160, 445], [161, 485], [158, 535], [151, 537], [151, 485], [152, 445], [151, 385], [150, 360]],
    armR: [[166, 272], [178, 279], [184, 315], [190, 355], [194, 385], [195, 397], [189, 401], [184, 389], [180, 359], [174, 321], [168, 295]],
    handR: [[192, 380], [195, 397], [189, 401], [184, 389]],
    shoeR: [[151, 532, 1], [159, 532], [163, 542], [164, 550], [151, 550, 1]]
  };
  function dressBox(D){
    var xs = [], ys = [];
    D.p.concat.apply(D.p, D.x || []).forEach(function(p){ xs.push(p[0], 300 - p[0]); ys.push(p[1]); });
    var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys) - 8, y1 = Math.max.apply(0, ys) + 4;
    var h = y1 - y0, w = Math.max(x1 - x0, h * .62), cx = (x0 + x1) / 2;
    return r(cx - w / 2) + ' ' + y0 + ' ' + r(w) + ' ' + h;
  }

  /* ---------- page wiring ---------- */
  var V = data.variants || [], st = {style: 'skater', size: 1, pat: PAT0, skin: 0, v: null, zoom: 1, touch: 0};
  var opts = (data.options || []).map(function(o){ return (o || '').toLowerCase(); });
  var colIx = Math.max(0, opts.findIndex ? opts.findIndex(function(o){ return /colou?r|design|pattern|print|style/.test(o); }) : 0);
  var lenIx = opts.findIndex ? opts.findIndex(function(o){ return /length|size|cut/.test(o); }) : -1;
  function isMetre(v){ return lenIx < 0 || !/swatch|sample/i.test(v.o[lenIx] || ''); }
  function imgOf(v){ return (v && v.img) || data.img; }
  function money(p){ return '£' + (p / 100).toFixed(2); }
  /* one entry per colour (the per-metre variant when there is a Length option) */
  var COLS = [];
  V.forEach(function(v){
    if (!isMetre(v)) return;
    var c = v.o[colIx] || v.title;
    if (!COLS.some(function(x){ return x.c === c; })) COLS.push({c: c, v: v});
  });
  function info(){ return doc.querySelector('.product-block-list__item--info'); }
  function pageVariant(){
    var i = info(), id = i && i.querySelector('form [name="id"]');
    var v = id && V.filter(function(x){ return String(x.id) === String(id.value); })[0];
    if (v && !isMetre(v)) v = V.filter(function(x){ return isMetre(x) && x.o[colIx] === v.o[colIx]; })[0] || v;
    return v || (COLS[0] && COLS[0].v) || V[0];
  }

  var root, stage, tag, out = {};
  function build(){
    root = doc.createElement('div'); root.className = 'brf-dp'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Plan your dress');
    root.innerHTML =
      '<div class="brf-dp__veil" data-x></div><div class="brf-dp__panel">' +
      '<button type="button" class="brf-dp__x" data-x aria-label="Close"><svg viewBox="0 0 14 14"><path d="M2 2l10 10M12 2L2 12"/></svg></button>' +
      '<div class="brf-dp__stage"><div class="brf-dp__tag"><i></i><span></span></div><div class="brf-dp__skins" aria-label="Model skin tone"></div><div class="brf-dp__note">Illustration</div></div>' +
      '<div class="brf-dp__side"><div class="brf-dp__scroll">' +
      '<h2 class="brf-dp__h">Plan your dress</h2><p class="brf-dp__lede">Pick a style and size and we’ll do the maths, then see it made up in this fabric.</p>' +
      '<div class="brf-dp__lab">1. Your dress <em data-o="sd"></em></div><div class="brf-dp__styles"></div>' +
      '<div class="brf-dp__lab">2. Your size</div><div class="brf-dp__chips" data-o="sizes"></div>' +
      '<div class="brf-dp__lab">3. Colour <em data-o="cn"></em></div><div class="brf-dp__sw"></div>' +
      '<div data-o="zw"><div class="brf-dp__lab">Print size</div><div class="brf-dp__chips" data-o="zoom"></div></div>' +
      '<div class="brf-dp__lab">4. Pattern</div><div class="brf-dp__chips" data-o="pats"></div><p class="brf-dp__why" data-o="why"></p>' +
      '</div><div class="brf-dp__foot"><div class="brf-dp__res"><div class="brf-dp__need">You’ll need about<b data-o="m"></b></div><div class="brf-dp__buy" data-o="buy"></div></div>' +
      '<button type="button" class="brf-dp__add"><span data-o="al"></span><span class="brf-dp__p" data-o="ap"></span></button><p class="brf-dp__warn" data-o="warn"></p>' +
      '<p class="brf-dp__small" data-o="small"></p></div>' +
      '<div class="brf-dp__fb" role="dialog" aria-label="Tell us what you think"></div></div></div>';
    doc.body.appendChild(root);
    [].forEach.call(root.querySelectorAll('[data-o]'), function(e){ out[e.getAttribute('data-o')] = e; });
    stage = root.querySelector('.brf-dp__stage'); tag = root.querySelector('.brf-dp__tag');
    [].forEach.call(root.querySelectorAll('[data-x]'), function(b){ b.addEventListener('click', close); });
    doc.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    var sg = root.querySelector('.brf-dp__styles');
    STYLES.forEach(function(s){
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'brf-dp__style'; b.setAttribute('data-k', s.k); b.title = s.d;
      b.appendChild(model(s.k, look(st.v), SKINS[0], false));
      b.appendChild(doc.createTextNode(s.n));
      b.addEventListener('click', function(){ var wasKid = !!cur().kids; st.style = s.k; if (!!s.kids !== wasKid) st.size = 1; paint(true); });
      sg.appendChild(b);
    });
    var sw = root.querySelector('.brf-dp__sw');
    COLS.forEach(function(c){
      var b = doc.createElement('button'); b.type = 'button'; b.title = c.c + (c.v.available ? '' : ' (sold out)'); b.setAttribute('aria-label', b.title);
      b.style.backgroundImage = 'url("' + imgOf(c.v).replace('width=900', 'width=120') + '")';
      if (!c.v.available) b.className = 'is-out';
      b.addEventListener('click', function(){ st.v = c.v; paint(true, true); });
      c.b = b; sw.appendChild(b);
    });
    if (COLS.length < 2) { sw.previousElementSibling.style.display = 'none'; sw.style.display = 'none'; }
    var sks = root.querySelector('.brf-dp__skins');
    SKINS.forEach(function(c, i){
      var b = doc.createElement('button'); b.type = 'button'; b.style.background = c; b.setAttribute('aria-label', 'Skin tone ' + (i + 1));
      b.addEventListener('click', function(){ st.skin = i; paint(false); }); sks.appendChild(b);
    });
    [['Smaller', .7], ['As photo', 1], ['Bigger', 1.4]].forEach(function(z){
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'brf-dp__chip'; b.textContent = z[0]; b.setAttribute('data-z', z[1]);
      b.addEventListener('click', function(){ st.zoom = z[1]; paint(false, true); }); out.zoom.appendChild(b);
    });
    out.pats.innerHTML = '';
    PATS.forEach(function(p){
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'brf-dp__chip'; b.setAttribute('data-k', p.k);
      b.innerHTML = p.n + (p.s ? '<small>' + p.s + '</small>' : '');
      b.addEventListener('click', function(){ st.pat = p.k; paint(false); }); out.pats.appendChild(b);
    });
    root.querySelector('.brf-dp__add').addEventListener('click', add);
    root.querySelector('.brf-dp__scroll').addEventListener('click', function(e){ if (e.target.closest('button')) st.touch++; });
  }
  function cur(){ return STYLES.filter(function(s){ return s.k === st.style; })[0]; }
  function buyM(){ return Math.ceil(metres(cur(), st.size, st.pat) - 1e-6); }

  var lastKey = '';
  function paint(swap, colour){
    var s = cur(), sizes = s.kids ? KIDS : ADULT, v = st.v, img = imgOf(v);
    if (st.size >= sizes.length) st.size = 1;
    [].forEach.call(root.querySelectorAll('.brf-dp__style'), function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-k') === st.style); });
    out.sd.textContent = s.d;
    out.sizes.innerHTML = '';
    sizes.forEach(function(z, i){
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'brf-dp__chip'; b.textContent = z; b.setAttribute('aria-pressed', i === st.size);
      b.addEventListener('click', function(){ st.size = i; paint(false); }); out.sizes.appendChild(b);
    });
    COLS.forEach(function(c){ c.b && c.b.setAttribute('aria-pressed', c.v === v); });
    var cnm = (v && (v.o[colIx] || v.title)) || ''; out.cn.textContent = cnm === 'Default Title' ? '' : cnm; /* one-colour fabric: "Skater in <fabric name>" */
    [].forEach.call(out.pats.children, function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-k') === st.pat); });
    var P = PATS.filter(function(p){ return p.k === st.pat; })[0];
    out.why.textContent = P.why + (st.pat === PAT0 && st.pat !== 'plain' ? ' We picked this for you from the fabric.' : '');
    [].forEach.call(root.querySelectorAll('.brf-dp__skins button'), function(b, i){ b.setAttribute('aria-pressed', i === st.skin); });

    var m = metres(s, st.size, st.pat), buy = Math.ceil(m - 1e-6);
    out.m.innerHTML = m.toFixed(1) + '<small>m</small>';
    out.buy.innerHTML = 'For ' + s.n.toLowerCase() + ' in ' + sizes[st.size] + ',<br>from this <strong>' + W + 'cm</strong> wide fabric.<br>Sold by the metre: <strong>' + buy + ' m</strong>';
    var price = v ? v.price * buy : 0, add = root.querySelector('.brf-dp__add');
    var stock = v && v.stock != null ? v.stock : Infinity, ok = v && v.available && stock >= buy;
    add.disabled = !ok; add.classList.remove('is-done');
    out.al.textContent = !v || !v.available ? 'Sold out in this colour' : (ok ? 'Add ' + buy + ' m to bag' : 'Not enough in stock');
    out.ap.textContent = ok ? money(price) : '';
    out.warn.textContent = v && v.available && !ok ? 'We have ' + stock + ' m of ' + (v.o[colIx] || 'this colour') + ' left. Try another colour.' : '';
    out.small.textContent = 'A guide from typical sewing patterns, so check your pattern’s envelope too.' + (SHEER ? ' This fabric is sheer, so you’ll probably want a lining.' : ' Lining not included.') + ' ';
    var fl = doc.createElement('button'); fl.type = 'button'; fl.className = 'brf-dp__fblink'; fl.textContent = 'Tell us what you think';
    fl.addEventListener('click', function(){ feedback(''); }); out.small.appendChild(fl);

    tag.querySelector('i').style.backgroundImage = 'url("' + img.replace('width=900', 'width=120') + '")';
    tag.querySelector('span').textContent = s.n + ' in ' + (out.cn.textContent || data.title);
    var lk = look(v, function(){ if (st.v === v) { lastKey = ''; paint(false, true); } });
    out.zw.style.display = (lk.plain || lk.mode === 'cover') && lk.ready ? 'none' : '';
    if (out.zoom.children[1]) out.zoom.children[1].textContent = lk.scaled ? 'True size' : 'As photo';
    var note = root.querySelector('.brf-dp__note'); if (note) note.textContent = lk.scaled && !lk.plain ? 'Print shown at true size' : 'Illustration';
    [].forEach.call(out.zoom.children, function(b){ b.setAttribute('aria-pressed', +b.getAttribute('data-z') === (st.zoom || 1)); });
    var key = st.style + '|' + img + '|' + st.skin + '|' + lk.ready + '|' + st.zoom;
    if (key === lastKey) return;
    if (lastKey.split('|')[1] !== img) colour = true;
    lastKey = key;
    if (colour) [].forEach.call(root.querySelectorAll('.brf-dp__style'), function(b){ var sv = b.querySelector('svg'); b.replaceChild(model(b.getAttribute('data-k'), lk, SKINS[0], false), sv); });
    var old = stage.querySelector('svg.brf-dp__model'), nu = model(st.style, lk, SKINS[st.skin], true);
    stage.__next = nu; /* the newest drawing wins, even if a fade is still running */
    if (old && swap) { stage.classList.add('is-swap'); setTimeout(function(){ var o = stage.querySelector('svg.brf-dp__model'); if (o !== stage.__next) stage.replaceChild(stage.__next, o); requestAnimationFrame(function(){ stage.classList.remove('is-swap'); }); }, 160); }
    else if (stage.classList.contains('is-swap')) {}
    else if (old) stage.replaceChild(nu, old); else stage.insertBefore(nu, stage.firstChild);
  }

  /* ---------- feedback ----------
     A short card: a face rating, what would make it better, an optional comment and email. It is sent to the shop's
     inbox through Shopify's contact form (into a hidden frame, so the page stays put) and also saved on the bag as a
     hidden note, so it shows on the order if they buy. Asked once (again after 30 days if skipped); never after sending. */
  var fbShown = false, FBK = 'brfDpFeedback';
  var IDEAS = ['More dress styles', 'Real photo model', 'Sleeve and length options', 'True print size', 'More sizes', 'Easier to use', 'Sewing pattern links'];
  var FACES = [[5, '😍', 'Love it'], [4, '🙂', 'Good'], [3, '😐', 'OK'], [2, '🙁', 'Not great'], [1, '😞', 'No help']];
  function fbDue(){ try { var v = localStorage.getItem(FBK); if (v === 'sent') return false; return !v || Date.now() - +v > 30 * 864e5; } catch (e) { return true; } }
  function hideFb(){ var f = root && root.querySelector('.brf-dp__fb'); f && f.classList.remove('is-on'); }
  function feedback(lead, thenClose){
    fbShown = true;
    var f = root.querySelector('.brf-dp__fb'), pick = {r: 0, ideas: []};
    f.innerHTML = '<button type="button" class="brf-dp__x" data-fbx aria-label="Not now"><svg viewBox="0 0 14 14"><path d="M2 2l10 10M12 2L2 12"/></svg></button>' +
      '<h2 class="brf-dp__h">' + lead + 'Quick question 🙂</h2><p class="brf-dp__lede">How helpful was the dress planner? It’s brand new and we’d love to make it better.</p>' +
      '<div class="brf-dp__faces">' + FACES.map(function(x){ return '<button type="button" class="brf-dp__face" data-r="' + x[0] + '" aria-pressed="false"><span>' + x[1] + '</span>' + x[2] + '</button>'; }).join('') + '</div>' +
      '<div class="brf-dp__lab">What would make it better? <em>Pick any</em></div><div class="brf-dp__chips">' +
      IDEAS.map(function(t){ return '<button type="button" class="brf-dp__chip" aria-pressed="false">' + t + '</button>'; }).join('') + '</div>' +
      '<textarea maxlength="800" placeholder="Anything else? What would you change or add?"></textarea>' +
      '<input type="email" placeholder="Your email (optional, if you’d like a reply)" autocomplete="email">' +
      '<button type="button" class="brf-dp__add" data-fbs disabled><span>Send feedback</span></button>' +
      '<p class="brf-dp__small"><button type="button" class="brf-dp__fblink" data-fbx>Not now</button></p>';
    var send = f.querySelector('[data-fbs]');
    [].forEach.call(f.querySelectorAll('.brf-dp__face'), function(b){ b.addEventListener('click', function(){
      pick.r = +b.getAttribute('data-r'); [].forEach.call(f.querySelectorAll('.brf-dp__face'), function(o){ o.setAttribute('aria-pressed', o === b); }); send.disabled = false;
    }); });
    [].forEach.call(f.querySelectorAll('.brf-dp__chips .brf-dp__chip'), function(b){ b.addEventListener('click', function(){
      var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', on);
      pick.ideas = [].filter.call(f.querySelectorAll('.brf-dp__chips .brf-dp__chip'), function(o){ return o.getAttribute('aria-pressed') === 'true'; }).map(function(o){ return o.textContent; });
      if (pick.ideas.length) send.disabled = false;
    }); });
    [].forEach.call(f.querySelectorAll('[data-fbx]'), function(b){ b.addEventListener('click', function(){
      try { localStorage.setItem(FBK, String(Date.now())); } catch (e) {}
      hideFb(); if (thenClose) close();
    }); });
    f.querySelector('textarea').addEventListener('input', function(){ if (this.value.trim()) send.disabled = false; });
    send.addEventListener('click', function(){
      var s = cur(), v = st.v, m = metres(s, st.size, st.pat);
      var lines = [
        'DRESS PLANNER FEEDBACK',
        'Rating: ' + (pick.r ? pick.r + '/5 (' + FACES.filter(function(x){ return x[0] === pick.r; })[0][2] + ')' : 'not given'),
        'Would make it better: ' + (pick.ideas.join(', ') || 'none picked'),
        'Comment: ' + (f.querySelector('textarea').value.trim() || '(none)'),
        'Product: ' + data.title,
        'They planned: ' + s.n + ', ' + (s.kids ? KIDS : ADULT)[st.size] + ', ' + ((v && (v.o[colIx] || v.title)) || '') + ', ' + m.toFixed(1) + ' m (' + st.pat + ')',
        'Page: ' + location.href.split('?')[0]
      ];
      var email = f.querySelector('input[type="email"]').value.trim();
      var form = doc.getElementById('brf-dp-fbform');
      if (form) {
        form.querySelector('[name="contact[email]"]').value = /.+@.+\..+/.test(email) ? email : 'dress-planner@bullringfabrics.co.uk';
        form.querySelector('[name="contact[body]"]').value = lines.join('\n');
        try { form.submit(); } catch (e) {}
      }
      try { fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {'_Dress planner feedback': lines.slice(1, 5).join(' | ')}})}); } catch (e) {}
      try { localStorage.setItem(FBK, 'sent'); } catch (e) {}
      f.innerHTML = '<div class="brf-dp__fbthanks"><b>💚</b><h2 class="brf-dp__h" style="padding:0">Thank you!</h2><p class="brf-dp__lede">You’re helping us make the dress planner better for every maker.</p></div>';
      setTimeout(function(){ hideFb(); if (thenClose) close(); }, 1800);
    });
    requestAnimationFrame(function(){ f.classList.add('is-on'); var b = f.querySelector('.brf-dp__face'); b && b.focus({preventScroll: true}); });
  }
  function fbForm(){
    if (doc.getElementById('brf-dp-fbform') || !doc.body) return;
    var t = doc.getElementById('brf-dp-fbtpl'); if (!t) return;
    var box = doc.createElement('div'); box.hidden = true;
    box.innerHTML = '<iframe name="brf-dp-fbframe" title="Feedback" tabindex="-1" style="display:none"></iframe>';
    box.appendChild(t.content.cloneNode(true)); doc.body.appendChild(box);
    var f = doc.getElementById('brf-dp-fbform'); if (f) f.target = 'brf-dp-fbframe';
  }

  var opener;
  function open(){
    if (!root) build();
    var pv = pageVariant(); if (!st.v || (pv && pv !== st.v)) { st.v = pv; lastKey = ''; }
    paint(false, true);
    opener = doc.activeElement;
    doc.documentElement.classList.add('brf-dp-lock');
    root.classList.add('is-open');
    setTimeout(function(){ var b = root.querySelector('.brf-dp__style[aria-pressed="true"]'); b && b.focus({preventScroll: true}); }, 60);
  }
  function close(){
    /* ask once, when someone has really tried it, before letting them go */
    if (!fbShown && st.touch >= 3 && fbDue()) { feedback('', true); return; }
    hideFb();
    root.classList.remove('is-open'); doc.documentElement.classList.remove('brf-dp-lock');
    opener && opener.focus && opener.focus({preventScroll: true});
  }

  /* pick the colour on the page, set the quantity, then press the page's own Add to bag */
  function setOpt(form, pos, val){
    var sel = form.querySelector('select[data-option-position="' + pos + '"]');
    if (sel) { var so = [].filter.call(sel.options, function(o){ return (o.getAttribute('data-value') || o.value) === val; })[0], sv = so ? so.value : val; if (sel.value !== sv) { sel.value = sv; sel.dispatchEvent(new Event('change', {bubbles: true})); } return; }
    var ins = form.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < ins.length; i++) if ((ins[i].getAttribute('data-value') || ins[i].value) === val && (ins[i].getAttribute('data-option-position') == pos || /option/i.test(ins[i].name || '') || ins[i].hasAttribute('data-option-position') === false)) {
      if (!ins[i].checked) { (ins[i].id && form.querySelector('label[for="' + ins[i].id + '"]') || ins[i]).click(); } return;
    }
  }
  function add(){
    var v = st.v, buy = buyM(), i = info(), btnEl = root.querySelector('.brf-dp__add');
    var form = i && i.querySelector('form[action*="/cart/add"]'), main = i && i.querySelector('.product-form__add-button');
    if (!v) return;
    btnEl.disabled = true; out.al.textContent = 'Adding…';
    function done(okk){
      if (okk) { btnEl.classList.add('is-done'); out.al.textContent = 'Added ' + buy + ' m to bag'; setTimeout(function(){ if (!fbShown && fbDue()) feedback('Added to your bag! ', true); else close(); }, 900); }
      else { out.warn.textContent = 'Sorry, that didn’t go in. Please try again.'; }
      setTimeout(function(){ btnEl.disabled = false; paint(false); }, okk ? 1200 : 400);
    }
    if (form && main) {
      v.o.forEach(function(val, k){ if (val != null) setOpt(form, k + 1, val); });
      /* Warehouse 7 redraws the variant picker after a pick, so wait (up to 3 seconds) for the page to switch to the chosen colour before pressing Add to bag */
      var tries = 0;
      (function wait(){
        var id = form.querySelector('[name="id"]');
        if (!id || String(id.value) !== String(v.id)) { if (++tries < 20) return setTimeout(wait, 150); return direct(); }
        main = i.querySelector('.product-form__add-button') || main;
        var q = i.querySelector('[name="quantity"]');
        if (q) {
          if (q.tagName === 'SELECT' && !q.querySelector('option[value="' + buy + '"]')) { var o = doc.createElement('option'); o.value = buy; o.textContent = buy; q.appendChild(o); }
          q.value = buy; q.dispatchEvent(new Event('input', {bubbles: true})); q.dispatchEvent(new Event('change', {bubbles: true}));
        }
        var t = setTimeout(function(){ doc.removeEventListener('product:added', hit, true); done(true); }, 2500);
        function hit(){ clearTimeout(t); doc.removeEventListener('product:added', hit, true); done(true); }
        doc.addEventListener('product:added', hit, true);
        if (main.disabled) { clearTimeout(t); doc.removeEventListener('product:added', hit, true); return direct(); }
        main.click();
      })();
    } else direct();
    function direct(){
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: v.id, quantity: buy})})
        .then(function(r){ if (!r.ok) throw 0; return r.json(); })
        .then(function(){ doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true})); doc.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true})); done(true); })
        .catch(function(){ done(false); });
    }
  }

  function card(){
    var i = info(), pay = i && i.querySelector('.product-form__payment-container');
    if (!pay || i.querySelector('.brf-dp-card')) return;
    var c = doc.createElement('button'); c.type = 'button'; c.className = 'brf-dp-card';
    c.innerHTML = '<span class="brf-dp-card__art"></span><span class="brf-dp-card__txt"><span class="brf-dp-card__t">Plan your dress</span><span class="brf-dp-card__s">See how much you need, and how it looks made up</span></span><span class="brf-dp-card__go">Try it</span>';
    /* Speed (2026-10-24 clean-up): reading the colour photo for the card's little dress took over half a second of
       work and two big photo downloads on every dress fabric page. The card now shows the plain placeholder dress
       straight away and only reads the photo once the card is near the screen and the browser is idle. */
    var started = false;
    function art(){
      var v = pageVariant(), a = c.querySelector('.brf-dp-card__art');
      var lk = started ? look(v, function(){ if (pageVariant() === v) art(); }) : {plain: true, color: '#D8D2CA'};
      a.innerHTML = ''; a.appendChild(model('skater', lk, SKINS[0], false));
    }
    function go(){ if (started) return; started = true; art(); }
    art();
    c.addEventListener('click', open);
    pay.parentNode.insertBefore(c, pay.nextSibling);
    var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 200); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){ if (es.some(function(e){ return e.isIntersecting; })) { io.disconnect(); idle(go, {timeout: 2000}); } }, {rootMargin: '200px'});
      io.observe(c);
    } else idle(go, {timeout: 2000});
    /* keep the card's little dress in the colour picked on the page */
    var form = pay.closest('form') || i;
    form.addEventListener('change', function(){ if (started) setTimeout(art, 60); });
  }
  function boot(){ fbForm(); card(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  window.brfDressPlanner = {open: open};
})();
